import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ContainerLayout } from "../components/ContainerLayout";
import AppBarHeader from "../components/Home/AppBarHeader";
import { AlterarEndereco } from "./habilitacao/AlterarEndereco";
export var Endereco = function () {
    return (_jsxs(_Fragment, { children: [_jsx(AppBarHeader, { titulo: "Editar Endere\u00E7o", voltarPara: "/home" }), _jsx(ContainerLayout, { children: _jsx(AlterarEndereco, { isInPage: true, setInputAlterado: function () { return null; } }) })] }));
};
